<template>
     <div class="container" v-title="'个人报名'">
         <Navigation-bar></Navigation-bar>
         <div class="container_content" v-show="pageShow">
             <div id="Personnel">
                <Title title="个人报名" subtitle="选择组别报名"></Title>
                <div class="enroll_operation">
                    <div>
                        <div class="registered">
                            <div>
                                <h4>已提交报名</h4>
                                <p>请前往报名记录页面查看</p>
                            </div>
                            <button v-href="`/Enroll/OneselfEnroll/AuditDetail?subLeagueId=${subLeagueId}`">前往</button>
                            <img src="~@images/enroll/代表队已报名.png">
                        </div>
                        <div class="pay" v-if="isNoPay">
                            <div>
                                <h4>未支付服务费</h4>
                                <p>请前往报名记录页面查看</p>
                            </div>
                            <button @click="showPay()">去支付</button>
                            <img src="~@images/enroll/未支付报名费.png">
                        </div>
                    </div>
                </div>
             </div>
         </div>
        <Alert-tip :tipData="alertTip" :tipShow="tipShow" @closeCallback="tipShow = false"  @btnCallback="btnCallback"></Alert-tip>
     </div>
</template>
<script>
import {
    GetMyIndividualEnrollStatus,
    GetUserEnrollPayStatusInfo, //查询支付状态
    CreateIndividualLeagueEnrollOrder //创建订单
} from '@/api';
import appInteraction from '@/common/appInteraction.js';
import communicate from '@/common/communicate.js';
import tools from '@/common/tools.js';

export default {
    name:"Personnel",
    data(){
        var subLeagueId = +this.$route.query.subLeagueId;
        return{
            subLeagueId: isNaN(subLeagueId) ? 0 : subLeagueId,
            pageShow: false,
            eventsId:0,
            isNoPay: false,
            alertTip:{},
            tipShow:false
        }
    },
    created(){
        GetMyIndividualEnrollStatus({
            LeagueId: this.subLeagueId
        }).then(data=>{
            if(data.Code == 0){
                if(data.EnrollStatus == 1){
                    this.pageShow = true;
					this.isNoPay = data.IsNotPaid;
                }else if(data.EnrollStatus == 2){
                    this.$navigation.replace(`/Enroll/OneselfEnroll/MyInfo?subLeagueId=${this.subLeagueId}&new=1`);
                }else if(data.EnrollStatus == 3){
                    this.$navigation.replace(`/Enroll/OneselfEnroll/AuditDetail?subLeagueId=${this.subLeagueId}&audit=1`);
                }
            }else if([3914].includes(data.Code)){
                this.alertTip = {
                    title: "温馨提示",
                    text: data.Message,
                    btnArr:[{
                        text:"知道了",
                        style:"color:#7AD21A"
                    }],
                    close:false
                };
                this.tipShow = true;
            }
        })
		//报名费支付状态
		communicate.enrollPayStatus.$on(()=>{
			GetUserEnrollPayStatusInfo({
				LeagueId: this.subLeagueId
			}).then(data => {
				if(data.Code == 0){
					this.isNoPay = data.IsNotPaid;
				}
			})
		});
        communicate.paySuccess.$on(()=>{
            this.isNoPay = false;
        })
    },
    destroyed(){
        communicate.enrollPayStatus.$off();
        communicate.paySuccess.$off();
    },
    methods:{
        btnCallback(){
            this.$navigation.back();
        },
        //去支付
		showPay(isConfirm){
			GetUserEnrollPayStatusInfo({
				LeagueId: this.subLeagueId
			}).then(data => {
				if(data.Code == 0){
                    if(isConfirm){
                        if(data.IsNotPaid){
                            this.$Prompt({
                                title: '温馨提示',
                                message: '未查询到支付成功',
                                confirmText: "知道了"
                            })
                        }else{
                            communicate.paySuccess.$emit();
                            this.isNoPay = false;
                        }
                    }else{
                        if(data.IsNotPaid){
                            this.go2pay();
                        }else{
                            this.$Prompt({
                                title: '温馨提示',
                                message: '您已支付',
                                confirmText: "知道了"
                            })
                            this.isNoPay = false;
                        }
                    }
				}
			})
		},
		go2pay(){
			CreateIndividualLeagueEnrollOrder({
				LeagueId: this.subLeagueId
			}).then(data => {
				if(data.Code == 0){
                    if(tools.isVersion('23061600')){
                        this.$navigation.go(`/Pay/EnrollCashier?money=${data.FeeTotal}&type=2&id=${data.LeagueEnrollOrderId}`);
                    }else{
                        let title,
                            message;
                        if(tools.isVersion('23060800')){
                            title = "支付提示";
                            message = `您是否已在微信小程序中完成支付?`;
                            appInteraction.jumpWxMiniApp(`/pages/pay/enrollCashier/enrollCashier?money=${data.FeeTotal}&type=201&id=${data.LeagueEnrollOrderId}`);
                        }else{
                            title = "去小程序支付";
                            message = `烦请您进入微信「亿动体育」小程序完成支付。<br/>
                                打开微信 >> 点击搜索 >> 选择小程序 >> 查找「亿动体育」>> 进入小程序`;
                        }
                        this.$Prompt({
                            title,
                            message,
                            showCancel: true,
                            cancelText: "未支付",
                            confirmText: "已支付"
                        }).then(confirm=>{
                            if(confirm){
                                this.showPay(true);
                            }
                        })
                    }
				}
			})
		}
    }
}
</script>
<style lang="scss" scoped>
.enroll_operation{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50%;
	transform: translateY(-50%);
}
.registered,
.pay{
    width: 670px;
    height: 122px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFFFFF;
    border-radius: 59px;
    padding: 0 40px 0 50px;
    box-sizing: border-box;
    box-shadow: 0 10px 19px 0 #EBF2F5;
    position: relative;
    div{
        h4{
            font-size: 32px;
            color: #3A3F49;
            line-height: 38px;
            font-weight: 500;
        }
        p{
            font-size: 26px;
            color: #7E7E7F;
            line-height: 36px;
            font-weight: 400;
            margin-top: 8px;
        }
    }
    button{
        width: 148px;
        @include line-height(68px);
        background: #1B1C1E;
        border-radius: 54px;
        font-size: 28px;
        color: #FFFFFF;
        text-align: center;
        font-weight: 500;
    }
    img{
        width: 280px;
        height: 284px;
        position: absolute;
        left: 31%;
        top: -114%;
    }
}

.pay{
    margin-top: 120px;
    div h4{
        color: #F34911;
    }
    img{
        width: 274px;
        height: 226px;
        left: 33%;
        top: -92%;
    }
}
</style>